import React, { FC } from 'react'
import './three-dots.css'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    color?: string
}

const ThreeDots: FC<Props> = (props) => {
    const { className: classProps, color = 'var(--splitcard-black)', ...divProps } = props
    const className = flatten('three-dots', classProps)
    const style = { '--dot-color': color } as React.CSSProperties

    return <div className={className} {...divProps} style={style}><span></span></div>
}

export default ThreeDots